import { Row, Table } from 'antd';
import { memo, useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import Detail from '../Detail';

import './style.scss';

import TableAdmin from '@/components/TableAdmin';
import revenueService from '@/services/revenue.service';
import { handleMessageError } from '@/util/handleMessageError';
import { numberFormatWithComma } from '@/util/numberFormatWithComma';
import moment from 'moment';
import { formatNumberMoney } from '@/util/formatNumberMoney';
interface IProps {
    data: any[];
    total: any;
    isLoading: boolean;
}
const Content: React.FC<IProps> = ({ data = [], total, isLoading }) => {
    const columns = [
        {
            title: 'STT',
            dataIndex: 'index',
            align: 'center',
        },
        {
            title: 'PHÒNG',
            align: 'center',
            dataIndex: 'phong',
            render: (value: any) => {
                return <>{value.roomNo}</>;
            },
        },
        {
            title: 'GIỜ NHẬN PHÒNG',
            align: 'center',
            dataIndex: 'starttime',
            render: (value: any) => moment(value).format('HH:mm:ss DD/MM'),
        },
        {
            title: 'GIỜ TRẢ PHÒNG',
            align: 'center',
            dataIndex: 'endtime',
            render: (value: any) => (value ? moment(value).format('HH:mm:ss DD/MM') : ''),
        },
        {
            title: 'THỜI GIAN SỬ DỤNG',
            align: 'center',
            dataIndex: 'thoigiansudung',
        },
        {
            title: 'TIỀN THU',
            align: 'center',
            render: (data: any) => {
                return data?.tienthu === 0 ? '-' : formatNumberMoney(data?.tienthu);
            },
        },
        {
            title: 'TÌNH TRẠNG',
            align: 'center',
            dataIndex: 'status',
            render: (value?: number) => {
                if (!value) return '';
                if (value === 1) return 'Đang thuê';
                if (value === 2) return 'Đã thanh toán';
            },
        },
    ];

    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [saleDataSelected, setDataSelected] = useState<any>();

    const onRowHandle = useCallback((data: any) => {
        setIsVisible(true);
        setDataSelected(data);
    }, []);

    useEffect(() => {
        console.log('data', data);
    }, [data]);

    return (
        <div className="p-revenue-content">
            <TableAdmin
                loading={isLoading}
                pointer={true}
                onRow={onRowHandle}
                columns={columns}
                data={data}
                rowKey="id"
                className="table_floor"
                summary={() => {
                    return (
                        <>
                            {data.length > 0 ? (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={5}>
                                        <Row justify="end">
                                            <strong>{'TỔNG TIỀN'}</strong>
                                        </Row>
                                    </Table.Summary.Cell>

                                    <Table.Summary.Cell index={1}>
                                        <Row justify="center">
                                            <strong>{formatNumberMoney(total?.tienphong)} ₫</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong></strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            ) : (
                                ''
                            )}
                        </>
                    );
                }}
            />
            <Detail onCancel={(data: boolean) => setIsVisible(data)} isVisible={isVisible} data={saleDataSelected} />
        </div>
    );
};

export default memo(Content);
